import React from 'react'
import { Heading, Body, getPictureProps } from '@superhi/design'

import SuperHiUnlimitedLogo from './components/Logo'
import JoinNowInfo from './components/JoinNowInfo'
import { Wrapper, BackgroundImage, Header } from './styles'

import PageHeaderHero from 'src/components/page-headers/PageHeaderHero'

const backgroundImageProps = getPictureProps({
  small: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/hero-small.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  medium: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/hero-medium.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  large: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/hero-large.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
  xlarge: {
    path: 'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/hero-large.png',
    width: 100,
    options: {
      fm: 'png8',
    },
  },
})

type Props = {}

const Hero: React.FC<React.PropsWithChildren<Props>> = () => (
  <Wrapper>
    <BackgroundImage
      {...backgroundImageProps}
      blurHash="eNS4yts+4liIOYyXXVr:NMnNKA-zTIs%pFyCoIxsW;t7kpoxo{bZt5"
      fit="cover"
      position="top center"
      alt=""
    />
    <PageHeaderHero
      header={
        <Header>
          <Heading level="1">
            <SuperHiUnlimitedLogo width={{ small: 260, medium: 400, large: 400 }} />
          </Heading>
          <Body maxWidth={26}>
            Meet our annual membership that unlocks all our courses, extra community perks, and
            early access.
          </Body>
        </Header>
      }
      align="center"
      footer={<JoinNowInfo />}
    />
  </Wrapper>
)

export default Hero
